import ModuleAdCreator from 'mfCreator/Editor';
export default ModuleAdCreator;
